import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Heading from "../../AdminComponents/Common/Heading";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { theme } from "../../Assets/Theme/theme";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";

function EditUser() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const passwordLogin = loginData?.user?.password
  const [inputValues, setInputValues] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const location = useLocation();
  const userDetails = location.state;

  useEffect(() => {
    setInputValues((prev) => ({
      ...prev,
      name: userDetails?.data?.user || state?.name || "",
      email: userDetails?.data?.email || state?.Email || "",
    }));
  }, [state]);

  const handleSubmit = async () => {
    setLoading(true);
    setErrors([]);

    const loginData = JSON.parse(localStorage.getItem("adminData"));
    const token = loginData?.token;

    let passwordToSend = null;
    if (inputValues.password) {
      passwordToSend = inputValues.password;
    } else if (passwordLogin) {
      passwordToSend = passwordLogin;
    }

    const dataPayload = {
      user: inputValues.name,
      email: inputValues.email,
    };

    if (passwordToSend) {
      dataPayload.password = passwordToSend;
    }

    try {
      const response = await axios.put(
        `${BASE_URL}/admin/user/${userDetails?.data?._id}/update`,
        dataPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.success === true) {
        toast.success("User updated successfully!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' },
        });
        navigate(-1);
      } else if (response?.data?.success === false) {
        setErrors(response?.data?.errors || []);

      } else {
        setErrors(response?.data?.errors || []);
      }
    } catch (error) {
      if (error?.response?.data?.success === false) {
        setErrors(error?.response?.data || '');

      } else {

        setErrors(error?.response?.data?.errors || []);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getErrorMessage = (field) => {
    if (!errors) return null;
  
    const errorList = Array.isArray(errors) ? errors : (errors.errors ? errors.errors : []);
  
    const fieldError = errorList.find((err) => err?.path === field);
    return fieldError?.msg || null;
  };
  

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [inputValues]);

  return (
    <Box>
      <Heading back={true} label={"Edit User"} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <Box width={{ md: "50%", xs: "100%" }}>
          <TextInput
            bgColor={"#f9f9f9"}
            label={"Username"}
            placeholder={"Enter Name"}
            value={inputValues.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
          {getErrorMessage("user") && (
            <Box color="red" mb={2}>
              {getErrorMessage("user")}
            </Box>
          )}
          <TextInput
            bgColor={theme.colors.inpGray}
            label={"Email"}
            placeholder={"Enter Email"}
            value={inputValues.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />

          {errors?.message && (
            <Box color="red" mb={2}>
              {errors?.message}
            </Box>
          )}
          {getErrorMessage("email") && (
            <Box color="red" mb={2}>
              {getErrorMessage("email")}
            </Box>
          )}
          <TextInput
            bgColor={theme.colors.inpGray}
            label={"Password"}
            placeholder={"Enter Password"}
            value={inputValues.password}
            type="password"
            onChange={(e) => handleChange("password", e.target.value)}
          />
          {getErrorMessage("password") && (
            <Box color="red" mb={2}>
              {getErrorMessage("password")}
            </Box>
          )}
          <CustomButton onClick={handleSubmit} disabled={loading}>
            {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : "Update"}
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
}

export default EditUser;
